const Card = ({ children, className = '', style, onClick }) => {
    return (
        <div
            className={`bg-white rounded-xl shadow-md p-6 ${className}`}
            style={style}
            onClick={onClick}
        >
            {children}
        </div>
    );
};

Card.Header = ({ children, divider = false }) => {
    return (
        <>
            <div>{children}</div>
            {divider && <hr className="my-2 border-gray-200" />}
        </>
    );
};

Card.Footer = ({ children, divider = false }) => {
    return (
        <div>
            {divider && <hr className="my-2 border-gray-200" />}
            {children}
        </div>
    );
};

export default Card;
